import useRouterPath from '@appmaker/core/hooks/useRouterPath';
import appmaker from '@appmaker/core/index';
import { Link } from '@appmaker/core/routes';
import { ArrowLeftIcon, DotsVerticalIcon } from '@heroicons/react/outline';
import DropDownMenu from '@appmaker/components/DropDownMenu';
import { useExtensionDetail } from '../store/details';
import UnSavedChange from './UnSaved';
import { useParams, useHistory } from '@appmaker/core/routes';

const DropDownMenuWrapper = ({
	onClickVersion = () => {},
	onClickDetails = () => {},
	onClickBackendSettings = () => {},
}) => {
	const { route } = useParams();
	const options = [];

	if (route !== 'version') {
		options.push({
			label: 'Version',
			onClick: onClickVersion,
			loading: false,
			isLoadingText: 'Loading...',
		});
	} else {
		options.push({
			label: 'Details',
			onClick: onClickDetails,
			loading: false,
			isLoadingText: 'Loading...',
		});
	}
	if(route !== 'backend-settings'){
		options.push({
			label: 'Backend settings',
			onClick: onClickBackendSettings,
			loading: false,
			isLoadingText: 'Loading...',
		});
	}else{
		options.push({
			label: 'Settings',
			onClick: onClickDetails,
			loading: false,
			isLoadingText: 'Loading...',
		});
	}
	
	return (
		<DropDownMenu
			button={
				<span className="p-1.5 bg-gray-200 hover:bg-gray-100 rounded-md text-gray-600 self-center inline-flex items-center space-x-1">
					<DotsVerticalIcon className="h-6 w-6 transform 2xl:rotate-90" />
					<span className="text-sm hidden 2xl:block font-medium">OPTIONS</span>
				</span>
			}
			options={options}
		/>
	);
};

export default function DetailHeader(props) {
	const { handle } = useParams();
	const getRouterPath = useRouterPath();
	const history = useHistory();
	const extension = useExtensionDetail((state) => state.extension);
	const {
		name: extensionName,
		id: extensionParamsId,
		icon,
	} = extension || {};

	/**
	 * Attach to header using filter
	 */
	const overRideHeaderInstalled = appmaker.applyFilters(
		`${extensionParamsId}-override-header-component-installed`,
		null,
		{
			extension: props.extension || {},
		}
	);
	const onClickVersion = () => {
		history.push(getRouterPath(`/extension/${handle}/version`));
	};
	const onClickDetails = () => {
		history.push(getRouterPath(`/extension/${handle}`));
	};
	const onClickBackendSettings = () => {
		history.push(getRouterPath(`/extension/${handle}/backend-settings`));
	};
	return (
		<div className="flex items-center justify-between space-x-3 bg-white shadow-sm px-4 py-2 sticky top-0 z-50">
			<div className="flex items-center space-x-3">
				<Link to={getRouterPath('/extension/')}>
					<ArrowLeftIcon className="h-8 w-8 p-2 hover:bg-gray-300 rounded-md text-gray-600" />
				</Link>
				<div className="aspect-square rounded-lg overflow-hidden bg-gray-100 h-10 w-10">
					<img
						src={
							icon ||
							'https://storage.googleapis.com/appilder_cdn/extension-default.png'
						}
						alt={`${extensionName}.`}
						className="object-center object-contain h-10 w-10"
					/>
				</div>
				<div>
					<h4 className="text-lg font-semibold text-gray-900">
						{extensionName}
					</h4>
				</div>
			</div>

			<div className="flex items-center space-x-2">
				<UnSavedChange />
				{overRideHeaderInstalled ? overRideHeaderInstalled : null}
				<DropDownMenuWrapper
					onClickVersion={onClickVersion}
					onClickDetails={onClickDetails}
					onClickBackendSettings={onClickBackendSettings}
				/>
			</div>
		</div>
	);
}
